import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/voucher-types.js';
import q from '../query.js';
export const voucherTypesEntity = `voucher-types`;
export const voucherTypesKey = 'voucher-types';
export const useVoucherTypes = (options) => q.query(voucherTypesKey, api.getTypes, keys.read.collection(voucherTypesEntity), { enabled: options?.enabled });
//# sourceMappingURL=index.js.map